module.exports = __webpack_public_path__ + "assets/img/ab23909c58de1a76df2315f367f8e148.png";